import type { TFunction } from 'i18next'

// The verb vocabulary is open — yaml authors can invent a new verb (e.g. a
// domain-specific action like `receiveStock`) without touching the frontend,
// so the `role.verb.*` bundle only ever covers what's been translated so far.
// `t`'s typed keys are generated from the bundle (see i18n/i18next.d.ts) and
// therefore can't accept an arbitrary runtime string, so the lookup key is
// cast at this single boundary; `defaultValue` still falls back to the raw
// verb for anything the bundle hasn't caught up with.
export function verbLabel(t: TFunction<'feature'>, verb: string): string {
  return t(`role.verb.${verb}` as never, { defaultValue: verb })
}
